"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comptroller__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AddReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "AddReservesOverflow",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowAndDepositBackFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowPaused",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "usdThreshold",
                type: "uint256",
            },
        ],
        name: "BorrowValueMustBeLargerThanThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "CantEnterPausedMarket",
        type: "error",
    },
    {
        inputs: [],
        name: "CantExitMarketWithNonZeroBorrowBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "CantSweepUnderlying",
        type: "error",
    },
    {
        inputs: [],
        name: "ComptrollerMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "EitherAssetOrDebtMustBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "cDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cBorrowVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suBorrowVal",
                type: "uint256",
            },
        ],
        name: "EitherAssetOrDebtMustBeZeroInGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpiredSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientCollateral",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientShortfall",
        type: "error",
    },
    {
        inputs: [],
        name: "InterMintNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBlockNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCloseFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidComptroller",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidDiscountRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidExchangeRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidGroupId",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInput",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInterestRateModel",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinSuBorrowValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReduceAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReserveFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureForRedeemFaceValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureLength",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidTimestamp",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsMax",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_SeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateCollateralMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketCanOnlyInitializeOnce",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MinDelayNotReached",
        type: "error",
    },
    {
        inputs: [],
        name: "MintMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MintPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MintTokensCantBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "NoRedemptionProvider",
        type: "error",
    },
    {
        inputs: [],
        name: "NotCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughForSeize",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingAfterRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingForMint",
        type: "error",
    },
    {
        inputs: [],
        name: "NotLiquidatableYet",
        type: "error",
    },
    {
        inputs: [],
        name: "NotSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdminOrPauser",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyListedCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPausedMarketCanBeUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPendingAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyRedemptionManager",
        type: "error",
    },
    {
        inputs: [],
        name: "OverThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "PriceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemTransferOutNotPossible",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSignerNotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "Reentered",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayBorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizePaused",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizeTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "Seize_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderMustBeCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "SetInterestRateModelMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SetReservesFactorMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenInOrAmountInMustBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferInFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferOutFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TooMuchRepay",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalBorrowsNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalSupplyNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "UnderlyingBalanceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowed",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "MarketEntered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "MarketExited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "MarketListed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "MarketUnlisted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint120",
                name: "borrowCap",
                type: "uint120",
            },
            {
                indexed: false,
                internalType: "uint120",
                name: "supplyCap",
                type: "uint120",
            },
        ],
        name: "NewCap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "compLogic",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "redemptionManager",
                type: "address",
            },
        ],
        name: "NewDependencies",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "closeFactorPercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minCloseValue",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minSuBorrowValue",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minWaitBeforeLiquidatable",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "largestGroupId",
                type: "uint8",
            },
        ],
        name: "NewGlobalConfig",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "heteroPercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "homoPercent",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "sutokenPercent",
                type: "uint64",
            },
        ],
        name: "NewLiquidationIncentive",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "ctoken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "mintPaused",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "borrowPaused",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "transferPaused",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "seizePaused",
                type: "bool",
            },
        ],
        name: "NewPause",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPauseGuardian",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPauseGuardian",
                type: "address",
            },
        ],
        name: "NewPauseGuardian",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "priceOracle",
                type: "address",
            },
        ],
        name: "NewPriceOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "timelock",
                type: "address",
            },
        ],
        name: "NewTimelock",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
        ],
        name: "RemoveAssetGroup",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "intraCRatePercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "intraMintRatePercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "intraSuRatePercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "interCRatePercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "interSuRatePercent",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isNewGroup",
                type: "bool",
            },
        ],
        name: "UpdateAssetGroup",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PAUSER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "newGroupId",
                type: "uint8",
            },
        ],
        name: "_changeGroupIdForAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "mintPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "borrowPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "transferPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "seizePaused",
                type: "bool",
            },
        ],
        name: "_pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "cTokens",
                type: "address[]",
            },
            {
                internalType: "uint120[]",
                name: "borrowCaps",
                type: "uint120[]",
            },
            {
                internalType: "uint120[]",
                name: "supplyCaps",
                type: "uint120[]",
            },
        ],
        name: "_setCaps",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "closeFactorPercent",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "minCloseValue",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minSuBorrowValue",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minWaitBeforeLiquidatable",
                        type: "uint32",
                    },
                    {
                        internalType: "uint8",
                        name: "largestGroupId",
                        type: "uint8",
                    },
                ],
                internalType: "struct GlobalConfig",
                name: "globalConfig_",
                type: "tuple",
            },
        ],
        name: "_setGlobalConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_governanceToken",
                type: "address",
            },
        ],
        name: "_setGovTokenAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "allowed",
                type: "bool",
            },
        ],
        name: "_setInterMintAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "largestGroupId",
                type: "uint8",
            },
        ],
        name: "_setLargestGroupId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "heteroPercent",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "homoPercent",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "sutokenPercent",
                        type: "uint16",
                    },
                ],
                internalType: "struct LiquidationIncentive",
                name: "liquidationIncentive_",
                type: "tuple",
            },
        ],
        name: "_setLiquidationIncentive",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPauseGuardian",
                type: "address",
            },
        ],
        name: "_setPauseGuardian",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "_setPriceOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_timelock",
                type: "address",
            },
        ],
        name: "_setTimelock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint120",
                name: "borrowCap",
                type: "uint120",
            },
            {
                internalType: "uint120",
                name: "supplyCap",
                type: "uint120",
            },
        ],
        name: "_supportMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "_unlistMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accountAssets",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allMarkets",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        name: "assetGroup",
        outputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint16",
                name: "intraCRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "intraMintRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "intraSuRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "interCRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "interSuRatePercent",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "borrowAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "borrowVerify",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "compLogic",
        outputs: [
            {
                internalType: "contract ICompLogic",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "cTokens",
                type: "address[]",
            },
        ],
        name: "enterMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cTokenAddress",
                type: "address",
            },
        ],
        name: "exitMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAllMarkets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAssetsIn",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenModify",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "getHypotheticalAccountLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "getUnderlyingPriceNormalized",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "globalConfig",
        outputs: [
            {
                internalType: "uint16",
                name: "closeFactorPercent",
                type: "uint16",
            },
            {
                internalType: "uint32",
                name: "minCloseValue",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "minSuBorrowValue",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "minWaitBeforeLiquidatable",
                type: "uint32",
            },
            {
                internalType: "uint8",
                name: "largestGroupId",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_admin",
                type: "address",
            },
            {
                internalType: "address",
                name: "_gov",
                type: "address",
            },
            {
                internalType: "address",
                name: "_compLogic",
                type: "address",
            },
            {
                internalType: "address",
                name: "_redemptionManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "_timelock",
                type: "address",
            },
            {
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "interMintAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isComptroller",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "isListed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastBorrowedAt",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "liquidateBorrowAllowed",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "actualRepayAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "seizeTokens",
                type: "uint256",
            },
        ],
        name: "liquidateBorrowVerify",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidationIncentive",
        outputs: [
            {
                internalType: "uint16",
                name: "heteroPercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "homoPercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "sutokenPercent",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "marketConfig",
        outputs: [
            {
                internalType: "bool",
                name: "mintPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "borrowPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "transferPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "seizePaused",
                type: "bool",
            },
            {
                internalType: "uint120",
                name: "borrowCap",
                type: "uint120",
            },
            {
                internalType: "uint120",
                name: "supplyCap",
                type: "uint120",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "markets",
        outputs: [
            {
                internalType: "bool",
                name: "isListed",
                type: "bool",
            },
            {
                internalType: "uint8",
                name: "assetGroupId",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "isComped",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "minter",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "mintAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "exchangeRate",
                type: "uint256",
            },
        ],
        name: "mintAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "exchangeRate",
                type: "uint256",
            },
        ],
        name: "redeemAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
        ],
        name: "redeemVerify",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "redemptionManager",
        outputs: [
            {
                internalType: "contract IRedemptionManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
        ],
        name: "removeAssetGroup",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrowAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "actualRepayAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowIndex",
                type: "uint256",
            },
        ],
        name: "repayBorrowVerify",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "seizeTokens",
                type: "uint256",
            },
        ],
        name: "seizeAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint16",
                name: "intraCRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "intraMintRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "intraSuRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "interCRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "interSuRatePercent",
                type: "uint16",
            },
        ],
        name: "setAssetGroup",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "transferTokens",
                type: "uint256",
            },
        ],
        name: "transferAllowed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "enum Version",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Comptroller__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Comptroller__factory = Comptroller__factory;
Comptroller__factory.bytecode = _bytecode;
Comptroller__factory.abi = _abi;
//# sourceMappingURL=Comptroller__factory.js.map